import _ from 'lodash'
import * as largeView from './large/index'
import config from './config.json'
import siteConfig from '../../abt-core/site-config.json'
import { composeTest } from '../../abt-utils/structure'

var liveConfig = _.find(window[siteConfig.imgServerConfig], { id: 'abt520' }) || {}

export default composeTest(config, liveConfig, {
  largeView: largeView,
  smallView: largeView
})



/*****************
 ** WEBPACK FOOTER
 ** ./src/abt-tests/abt520/test.js
 ** module id = 53
 ** module chunks = 2
 **/